module.exports = __webpack_public_path__ + "img/asset7.5622d38f.png";